export default __webpack_public_path__ + "static/media/web_login_logo.3cabc861.png";